var _rect, _g, _g2, _rect2, _rect3, _rect4, _rect5, _polyline, _polyline2, _rect6, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteDesignA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    "data-name": "Laag 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    y: 48,
    width: 800,
    height: 551,
    fill: "#f5f5f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website_Menu",
    "data-name": "Website Menu"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 48,
    width: 800,
    height: 40,
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 64,
    width: 80,
    height: 8,
    rx: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 64,
    width: 80,
    height: 8,
    rx: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 64,
    width: 80,
    height: 8,
    rx: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 64,
    width: 80,
    height: 8,
    rx: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 64,
    width: 80,
    height: 8,
    rx: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 64,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Browser_Menu",
    "data-name": "Browser Menu"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 48,
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,13a4,4,0,1,1-4-4A4,4,0,0,1,24,13Z",
    transform: "translate(0 -1)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,13a4,4,0,1,1-4-4A4,4,0,0,1,40,13Z",
    transform: "translate(0 -1)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,13a4,4,0,1,1-4-4A4,4,0,0,1,56,13Z",
    transform: "translate(0 -1)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 24,
    width: 560,
    height: 16,
    rx: 2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 592,
    y: 24,
    width: 192,
    height: 16,
    rx: 2,
    fill: "#fff"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.39,
    y: 109.21,
    width: 174.67,
    height: 11.34,
    fill: "#666"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.64,
    y: 137.9,
    width: 56.48,
    height: 8.5,
    fill: "#898989"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 103.17,
    y: 137.9,
    width: 56.48,
    height: 8.5,
    fill: "#898989"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 185.17,
    y: 137.9,
    width: 56.48,
    height: 8.5,
    fill: "#898989"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "87.56 137.9 92.17 142.5 87.56 147.11",
    fill: "none",
    stroke: "#898989",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "169.65 137.9 174.25 142.5 169.65 147.11",
    fill: "none",
    stroke: "#898989",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 167.94,
    width: 758,
    height: 410.78,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M781,580.71H21V167.94H781Zm-758-2H779V169.94H23Z",
    transform: "translate(0 -1)",
    fill: "#4b55f6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteDesignA);
export default __webpack_public_path__ + "static/media/siteDesignA.e74af643338dfc93a9b02638c5588e02.svg";
export { ForwardRef as ReactComponent };